import { Map } from 'immutable'
import {
  none,
  Option,
  some,
} from 'widgets-for-react'
import { createButtonData } from '../../utils'
import { linkWrapper } from '../cms/blocks/utils.gen'
import { DownloadBlockStyle } from '../cms/blocks/widgets/downloadBlock.gen'
import { getFormState } from '../form/api'
import { getGravityFormState } from '../gravityform/api'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import { PublicSite_CustomPageData } from './application.mod'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { BarometerBlockStyle, GraphProps } from './blocks/custom_blocks/widgets/barometer'
import { CarouselBlockItem } from './blocks/custom_blocks/widgets/carouselBlock'
import { GridBlockItem } from './blocks/custom_blocks/widgets/gridBlock.mod'
import { GridHighlightsBlockStyle } from './blocks/custom_blocks/widgets/gridHighlightsBlock'
import { StringToHeaderType } from './blocks/custom_blocks/widgets/headerBlock.mod'
import { ImageGalleryBlockStyle } from './blocks/custom_blocks/widgets/imageGalleryBlock'
import { LinkProps } from './blocks/custom_blocks/widgets/linkBlock'
// import { cookiebar } from './templates/cookiebar.mod'
import { MediaBlockStyle } from './blocks/custom_blocks/widgets/mediaBlock'
import { QuoteBlockStyle } from './blocks/custom_blocks/widgets/quoteBlock'
import { StepsBlockStyle } from './blocks/custom_blocks/widgets/stepsBlock'
import { TextBlockStyle } from './blocks/custom_blocks/widgets/textBlock'
import {
  carouseBlockClasses, ctaBlockClasses, downloadBlockClasses,
  formBlockClasses, gravityFormBlockClasses, iframeBlockClasses, mediaBlockClasses,
  newsletterBlockClasses,
  quoteBlockClasses,
  tableBlockClasses, textBlockClasses
} from './blocks/style.mod'
import { countries_list, countries_list_de, countries_list_nl } from './utils/countries.mod'
import { mapLanguage } from '../../helpers'
import { get_lang_from_url } from '../map/maps_utils'
import { zeroWebshopState } from './templates/BrochuresWebshop/brochuresWebshop.widget'

export const CustomBlock_To_Widget = (
  c: CustomBlock,
  block_index: number,
  extra_data: PublicSite_CustomPageData
): Option<CustomBlockData> => {
  if (c.kind == 'vidda/download') {
    const vidda_download: CustomBlockData = {
      kind: 'downloadsBlock',
      value: {
        fst: {
          index: block_index,
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          items: c.innerBlocks.map((downloadItem, index) => {
            return {
              key: index.toString(),
              title: downloadItem.attrs.title,
              text: downloadItem.attrs.file_name,
              file_url: downloadItem.attrs.url
            }
          }),
          useSVGIcons: false
        },
        snd: downloadBlockClasses as DownloadBlockStyle
      }
    }
    return some(vidda_download)
  }

  if (c.kind == 'vidda/text') {
    const vidda_text: CustomBlockData = {
      kind: 'textBlock',
      value: {
        fst: {
          title: c.attrs.title,
          text: c.attrs.text,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          has_show_more: c.attrs.has_show_more
        },
        snd: textBlockClasses as TextBlockStyle
      }
    }

    return some(vidda_text)
  }

  if (c.kind == 'vidda/form') {
    let res = getFormState([], c.attrs.form_id, [])

    //we can implement here the mapping to translate the english names of the countries
    // let lst = []
    // for (let [key, value] of Object.entries(CountriesList.countries)) {
    //   lst.push(value.name)
    // }
    // lst = lst.sort()
    res.context.external_options = Map<string, string[]>()
      .set("all_countries", countries_list)
      .set('all_countries_nl', countries_list_nl)
      .set('all_countries_de', countries_list_de)

    return some({
      kind: 'formBlock',
      value: {
        fst: {
          block_index: block_index,
          form_id: c.attrs.form_id,
          state: res
        },
        snd: formBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/gravity-form') {
    let res = getGravityFormState([], c.attrs.form_id, mapLanguage(get_lang_from_url(_ => "")))

    res.context.external_options = Map<string, string[]>()
    return some({
      kind: 'gravityFormBlock',
      value: {
        fst: {
          blockIndex: block_index,
          formId: c.attrs.form_id,
          state: res
        },
        snd: gravityFormBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/newsletter') {
    return some({
      kind: 'newsletterBlock',
      value: {
        fst: {
          block_index: block_index,
          newsletter: c.attrs.newsletter,
          initialNewsletter: c.attrs.newsletter, // Do not edit this value in the state
        },
        snd: newsletterBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/table') {
    return some({
      kind: 'tableBlock',
      value: {
        fst: {
          block_index: block_index,
          html: c.attrs.html
        },
        snd: tableBlockClasses
      }
    })
  }

  if (c.kind == 'vidda/latest') {
    return some({
      kind: 'latestBlock',
      value: {
        fst: {
          title: c.attrs.title,
          button: {
            title: c.attrs.button_text,
            url: '/updates'
          },
          hasBackground: c.attrs.hasBackground,
          display:
            c.attrs.variant == 'selected'
              ? { kind: 'selected', ids: c.attrs.ids }
              : { kind: 'latest' }
        },
        snd: {}
      }
    })
  }

  if (c.kind == 'vidda/media') {
    const vidda_media: CustomBlockData = {
      kind: 'mediaBlock',
      value: {
        fst: c.attrs.type == 'image' ? {
          // image: c.attrs.type == 'video' ? null : c.attrs.image,
          type: 'image',
          useCookieBar: false,
          caption: c.attrs.caption,
          image: c.attrs.image
        } : {
          type: 'video',
          caption: (c.attrs.caption && c.attrs.caption.length != 0) ? c.attrs.caption : null,
          useCookieBar: true,
          video: {
            id: c.attrs.video.id,
            url: c.attrs.video.url,
            type: c.attrs.video.type,
            frameBorder: c.attrs.video.frameBorder,
            allowFullScreen: c.attrs.video.allowFullScreen
          }
        },
        snd: mediaBlockClasses as MediaBlockStyle
      }
    }
    return some(vidda_media)
  }

  if (c.kind == 'vidda/link-list') {
    const vidda_link_list: CustomBlockData = {
      kind: 'linkListBlock',
      value: {
        fst: {
          index: null,
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          items: c.innerBlocks.map((linkItem, index) => {
            let link = linkWrapper({ title: linkItem.attrs.link_text, url: linkItem.attrs.link_url })
            return {
              key: index.toString(),
              title: link.title,
              url: link.url,
              is_link_external: link.is_link_external
            } as LinkProps
          }),
          useSVGIcons: false,
        },
        snd: null
      }
    }
    return some(vidda_link_list)
  }

  if (c.kind == 'vidda/expandable') {
    const vidda_expandable: CustomBlockData = {
      kind: 'expandableBlock',
      value: {
        fst: {
          title: c.attrs.title,
          intro: c.attrs.intro,
          link: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? linkWrapper({ title: c.attrs.button_text, url: c.attrs.button_url }) : null,
          index: block_index,
          items: c.innerBlocks.map((expandableItem, index) => {
            return {
              index: index,
              key: index.toString(),
              title: expandableItem.attrs.title,
              open: false,
              useSVGIcons: false,
              blocks: expandableItem.innerBlocks.map(innerBlock => innerBlock.innerHTML)
            }
          })
        },
        snd: null
      }
    }

    return some(vidda_expandable)
  }

  if (c.kind == 'vidda/quote') {
    const vidda_quote: CustomBlockData = {
      kind: 'customQuoteBlock',
      value: {
        fst: {
          index: block_index,
          text: c.attrs.text,
          author: c.attrs.author,
          company: c.attrs.company,
          primary_button: c.attrs.primary_button_text && c.attrs.primary_button_url
            ? linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url })
            : null,
          secondary_button: c.attrs.secondary_button_text && c.attrs.secondary_button_url
            ? linkWrapper({ title: c.attrs.secondary_button_text, url: c.attrs.secondary_button_url })
            : null,
          image: c.attrs.image,
        },
        snd: quoteBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_quote)
  }

  if (c.kind == 'vidda/iframe') {
    return some({
      kind: 'iframeBlock',
      value: {
        fst: {
          index: block_index,
          link: c.attrs.url
        },
        snd: iframeBlockClasses
      }
    } as CustomBlockData)
  }

  if (c.kind == 'vidda/header') {
    const vidda_header: CustomBlockData = {
      kind: 'headerBlock',
      value: {
        fst: {
          blockName: 'vidda/header',
          header_type: StringToHeaderType(c.attrs.header_type),
          // image_focus: c.attrs.image_focus ? c.attrs.image_focus : 'middle',
          title: c.attrs.title,
          // subtitle: c.attrs.subtitle,
          intro: c.attrs.intro,
          image: c.attrs.image,
          image_mobile: c.attrs.image_mobile,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && (c.attrs.primary_button_url || c.attrs.link_to_form_block) ? createButtonData(c.attrs.primary_button_text, c.attrs.link_to_form_block ? '#form-block' : c.attrs.primary_button_url) : null,
          link_to_form_block: c.attrs.show_primary && c.attrs.link_to_form_block ? true : false,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          open_primary_new_tab: c.attrs.open_primary_new_tab, 
          open_secondary_new_tab: c.attrs.open_secondary_new_tab,
          // video_small: c.attrs.video_small ? c.attrs.video_small : null,
          // video_medium: c.attrs.video_medium ? c.attrs.video_medium : null,
          // video_large: c.attrs.video_large ? c.attrs.video_large : null
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_header)
  }

  if (c.kind == 'vidda/image-text') {
    const vidda_image_text: CustomBlockData = {
      kind: 'imageTextBlock',
      value: {
        fst: {
          blockName: 'vidda/image-text',
          image_position: c.attrs.image_position,
          image: c.attrs.image,
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_image_text)
  }

  if (c.kind == 'vidda/grid' || c.kind == 'vidda/grid-with-image') {
    const vidda_grid: CustomBlockData = {
      kind: 'gridBlock',
      value: {
        fst: {
          blockName: 'vidda/grid',
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          blocks: c.innerBlocks.map(innerBlock => {
            return {
              title: innerBlock.attrs.title,
              intro: innerBlock.attrs.intro,
              image: innerBlock.attrs.image,
              link: innerBlock.attrs.link_url ? linkWrapper({ title: innerBlock.attrs.link_text, url: innerBlock.attrs.link_url }) : undefined
            } as GridBlockItem
          })
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_grid)
  }

  if (c.kind == 'vidda/grid-highlights') {
    const vidda_grid: CustomBlockData = {
      kind: 'gridHighlightsBlock',
      value: {
        fst: {
          block_index: block_index,
          title: c.attrs.title,
          intro: c.attrs.intro,
          pages: c.attrs.pages,
          conferences: c.attrs.conferences,
          webinars: c.attrs.webinars,
          data: Map(), 
          current_page: 1, 
          size: 30,
          total_pages: none()
        },
        snd: textBlockClasses as GridHighlightsBlockStyle,
      },
    }

    return some(vidda_grid)
  }

  if (c.kind == 'vidda/carousel') {
    const vidda_grid: CustomBlockData = {
      kind: 'carouselBlock',
      value: {
        fst: {
          blockName: 'vidda/carousel',
          title: c.attrs.title,
          intro: c.attrs.intro,
          show_random_items: c.attrs.show_random_items,
          primary_button:
            c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url
              ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url)
              : null,
          secondary_button:
            c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url
              ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url)
              : null,
          blocks: c.innerBlocks.map((innerBlock) => {
            return {
              title: innerBlock.attrs.title,
              intro: innerBlock.attrs.intro,
              image: innerBlock.attrs.image,
              link: innerBlock.attrs.link_url,
              is_video: innerBlock.attrs.is_video,
              label: innerBlock.attrs.label,
            } as CarouselBlockItem
          }),
        },
        snd: carouseBlockClasses,
      },
    }

    return some(vidda_grid)
  }

  if (c.kind == 'vidda/facts-and-figures') {
    const vidda_facts_and_figures: CustomBlockData = {
      kind: 'factsAndFiguresBlock',
      value: {
        fst: {
          blockName: 'vidda/facts-and-figures',
          items: c.innerBlocks.map(item => {
            return {
              amount: item.attrs.amount,
              label: item.attrs.label,
              intro: item.attrs.intro,
              image: item.attrs.hasIcon && item.attrs.image ? item.attrs.image : null
            }
          })
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_facts_and_figures)
  }
  if (c.kind == 'vidda/cta') {
    const vidda_cta: CustomBlockData = {
      kind: 'ctaBlock',
      value: {
        fst: {
          blockName: 'vidda/cta',
          title: c.attrs.title,
          intro: c.attrs.intro,
          image: c.attrs.image,
          image_position: c.attrs.image_position,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
        },
        snd: ctaBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_cta)
  }

  if (c.kind == 'vidda/image-stack') {
    const vidda_image_stack: CustomBlockData = {
      kind: 'imageStackBlock',
      value: {
        fst: {
          block_index: block_index,
          blockName: 'vidda/image-stack',
          title: c.attrs.title,
          intro: c.attrs.intro,
          items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }

    return some(vidda_image_stack)
  }

  if (c.kind == 'vidda/attention') {
    const vidda_image_stack: CustomBlockData = {
      kind: 'attentionBlock',
      value: {
        fst: {
          blockName: 'vidda/attention',
          title: c.attrs.title,
          image: c.attrs.image,
          link: c.attrs.link_text && c.attrs.link_url ? linkWrapper({ title: c.attrs.link_text, url: c.attrs.link_url }) : null
        },
        snd: textBlockClasses as QuoteBlockStyle,
      },
    }

    return some(vidda_image_stack)
  }

  if (c.kind == 'vidda/gallery') {
    const vidda_image_gallery: CustomBlockData = {
      kind: 'imageGalleryBlock',
      value: {
        fst: {
          blockName: 'vidda/gallery',
          title: c.attrs.title,
          intro: c.attrs.intro,
          items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
        },
        snd: textBlockClasses as ImageGalleryBlockStyle
      }
    }

    return some(vidda_image_gallery)
  }

  if (c.kind == 'vidda/featured-content') {
    const vidda_featured_content: CustomBlockData = {
      kind: 'featuredContentBlock',
      value: {
        fst: {
          blockName: 'vidda/featured-content',
          label: c.attrs.label,
          title: c.attrs.title,
          intro: c.attrs.intro,
          button: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? createButtonData(c.attrs.button_text, c.attrs.button_url) : null,
          button_2: c.attrs.show_button_2 && c.attrs.button_url_2 && c.attrs.button_text_2 ? createButtonData(c.attrs.button_text_2, c.attrs.button_url_2) : null,
          image_position: c.attrs.image_position,
          image: c.attrs.image,
          block_width: c.attrs.block_width ? c.attrs.block_width : 'big'
        },
        snd: null
      }
    }

    return some(vidda_featured_content)

  }
  if (c.kind == 'vidda/steps') {
    const vidda_steps_block: CustomBlockData = {
      kind: 'stepsBlock',
      value: {
        fst: {
          blockName: 'vidda/steps',
          index: block_index,
          image: c.attrs.image,
          title: c.attrs.title,
          blocks: c.innerBlocks.map(innerBlock => {
            return {
              attrs: {
                title: innerBlock.attrs.title,
                text: innerBlock.attrs.content
              }
            }
          }),
          primary_button: c.attrs.show_primary_button ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary_button ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
        },
        snd: textBlockClasses as StepsBlockStyle
      }
    }

    return some(vidda_steps_block)
  }
  if (c.kind == 'vidda/video') {
    const video: CustomBlockData = {
      kind: 'videoBlock',
      value: {
        fst: {
          url: c.attrs.url,
          caption: c.attrs.caption,
          contentWidth: c.attrs.contentWidth, 
          embed_url: c.attrs.embed_url, 
          hasIntro: c.attrs.hasIntro, 
          hasTitle: c.attrs.hasTitle, 
          isUpload: c.attrs.isUpload, 
          intro: c.attrs.intro, 
          title: c.attrs.title,

        },
        snd: mediaBlockClasses
      }
    }
    return some(video)
  }
  if (c.kind == 'vidda/barometer') {
    const vidda_steps_block: CustomBlockData = {
      kind: 'barometerBlock',
      value: {
        fst: {
          blockName: 'vidda/barometer',
          index: block_index,
          title: c.attrs.title,
          text: c.attrs.text,
          graphs: c.innerBlocks.map((graph, index) => {
            return {
              key: index.toString(),
              label: graph.attrs.label,
              target_label: graph.attrs.target_label,
              current: graph.attrs.current,
              target: graph.attrs.target,
              min: graph.attrs.min,
              max: graph.attrs.max
            } as GraphProps
          }),

        },
        snd: textBlockClasses as BarometerBlockStyle
      }
    }

    return some(vidda_steps_block)
  }
  if (c.kind == 'vidda/game-block') {
    const game: CustomBlockData = {
      kind: "gameBlock", 
      value: {
        fst: {},
        snd: {}
      }
    }
    return some(game) 
  } 

  if (c.kind == 'vidda/brochures') {
    const brochures: CustomBlockData = {
      kind: 'brochuresBlock',
      value: {
        fst: {
          title: c.attrs.title,
          country: c.attrs.country,
          country_name: c.attrs.country_name,
          description: c.attrs.description,
          block_index: block_index,
          isDownload: c.attrs.isDownload,
          state: zeroWebshopState
        },
        snd: {}
      }
    }
    return some(brochures)
  }

  return none()
}